export default __webpack_public_path__ + "static/media/ic-no-announcements.b2648694.svg";